import React, {useEffect, useState} from "react";
import styles from "./your-birthdate.module.css";
import {Page} from "../../components/page/page";
import {DateTimeButton} from "../../../../components/date-time-button/date-time-button";
import {useDispatch, useSelector} from "react-redux";
import {setBirthDate} from "../../store/stateSlice";
import {isValidDate} from "../../../../util";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const range = (start, end) =>
  Array.from({ length: end - start }, (v, k) => k + start);

const YourBirthdatePage = () => {
  const state = useSelector((store) => store.tarot);
  const dispatch = useDispatch();
  const [selectedDay, selectDay] = useState(state.birthDate.day || "day");
  const [selectedMonth, selectMonth] = useState(
    state.birthDate.month || "month"
  );
  const [selectedYear, selectYear] = useState(state.birthDate.year || "year");

  const [isDateValid, setDateValid] = useState(false);

  useEffect(() => {
    let isValid = selectedDay !== "day" &&
        selectedMonth !== "month" &&
        selectedYear !== "year" &&
        isValidDate(selectedYear, selectedMonth, selectedDay)
    setDateValid(isValid)
  }, [selectedDay, selectedMonth, selectedYear]);

  const dateTimeButtonStyles = {
    borderColor: '#ffffff',
    borderRadius: '12px',
    backgroundColor: 'rgba(24, 18, 57, .8)'
  }

  return (
    <Page
      title="What is your date of birth?"
      nextPageLink="../your-birthplace"
      onContinue={() =>
        dispatch(
          setBirthDate({
            day: selectedDay,
            month: selectedMonth,
            year: selectedYear,
          })
        )
      }
      canGoToNextPage={isDateValid}
    >
      <div>
        <div className={styles.date_button_container}>
          <DateTimeButton
            id="day"
            value={selectedDay}
            dateTimeButtonStyles={dateTimeButtonStyles}
            onChange={(e) => selectDay(parseInt(e.target.value))}
          >
            <option value="day" hidden>
              Day
            </option>
            {[...Array(31)].map((el, i) => (
              <option key={i} value={i + 1} selected>
                {i + 1}
              </option>
            ))}
          </DateTimeButton>
        </div>
        <div className={styles.date_button_container}>
          <DateTimeButton
            id="month"
            value={months[selectedMonth]}
            dateTimeButtonStyles={dateTimeButtonStyles}
            onChange={(e) => selectMonth(months.indexOf(e.target.value))}
          >
            <option value="month" hidden>
              Month
            </option>
            {months.map((el, i) => (
              <option key={i} value={el}>
                {el}
              </option>
            ))}
          </DateTimeButton>
        </div>
        <div className={styles.date_button_container}>
          <DateTimeButton
            id="year"
            value={selectedYear}
            dateTimeButtonStyles={dateTimeButtonStyles}
            onChange={(e) => selectYear(parseInt(e.target.value))}
          >
            <option value="year" hidden>
              Year
            </option>
            {[...range(1940, 2024)].reverse().map((el, i) => (
              <option key={i} value={el}>
                {el}
              </option>
            ))}
          </DateTimeButton>
        </div>
        {(
                selectedDay !== "day" &&
                selectedMonth !== "month" &&
                selectedYear !== "year" &&
                !isValidDate(selectedYear, selectedMonth, selectedDay)) &&
            <span className={styles.error_text}>Please enter a valid date</span>}
      </div>
    </Page>
  );
};

export { YourBirthdatePage };
